module.exports = __webpack_public_path__ + "static/instagram-c9a54e4436614336849e435a21d207a7.svg";